/*
 * Copyright (c) 2019. Nedaware SL
 */

import {Resource} from "../../api/resource";
import {BaseEntity} from "../base-entity.model";

/**
 * Nedaware S.L.
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */
export abstract class PuntoRecogida extends Resource {
}
